import { convertEventName } from '@/utils/convertEventName'
import { storage } from '@/utils/storage'

export default defineNuxtPlugin((nuxtApp) => {
  const { $bridge, $gtag, $fb, $kwaiq, $tiktok } = nuxtApp

  let pageTitle = ''

  function push(obj, eventID = null) {
    const userInfoStore = nuxtApp.$pinia?._s.get('userInfo')
    const profile = userInfoStore?.userInfo || {}
    const user_properties = {
      level: profile.level || 0,
      channel: profile.channel || '',
      subChannel: profile.sub_channel || '',
      strategy: profile.strategy || '',
      scope: profile.scope || '',
      topup: profile.topup || 0,
      verification_status: profile.verification_status || 0,
      uidSite: profile.uid_site || '',
      user_tag_RFM: profile.user_tag || '',
      agent_id: profile.agent_id || '',
    }
    const objData = { ...obj, user_id: user_properties.uidSite, user_properties }
    setPageTitle(objData)

    // 針對特定追蹤平台的金額與幣別轉換邏輯 (VNDK -> VND, IDRK -> IDR, 且金額 * 1000)
    const isSpecialCurrency = ['VNDK', 'IDRK'].includes(objData.currency)
    const specialData = isSpecialCurrency
      ? {
          ...objData,
          value: objData.value ? Number(objData.value) * 1000 : objData.value,
          app_value: objData.app_value ? Number(objData.app_value) * 1000 : objData.app_value,
          currency: objData.currency.replace('K', ''),
        }
      : objData

    const kpix = storage.get('kpix')
    if ($kwaiq?.instance && kpix) {
      $kwaiq.instance(kpix)?.track(convertEventName(obj.event, 'kwai'), specialData)
    }

    if ($gtag) {
      $gtag('event', obj.event, specialData)
    }

    if ($fb) {
      $fb.query('trackCustom', convertEventName(obj.event, 'facebook'), specialData, eventID)
    }

    if ($tiktok) {
      $tiktok.track(convertEventName(obj.event, 'tiktok'), specialData)
    }

    if ($bridge?.available) {
      $bridge.callHandler('pushEvents', objData, () => {
        console.log('[Bridge] Push Events')
      })
    }
    window.jsBridge?.postMessage(obj.event, JSON.stringify(objData || {}))
    console.info(
      `%c[Analytics][DEFAULT: ${obj.event} | KWAI: ${convertEventName(obj.event, 'kwai')} | FB: ${convertEventName(obj.event, 'facebook')} | TIKTOK: ${convertEventName(obj.event, 'tiktok')}]`,
      'background-color: #fff000; color: #000000;'
    )
    // 重置pageTitle
    if (objData.event === 'close_page') {
      pageTitle = ''
    }
  }

  function setPageTitle(objData) {
    // 暫存pageTitle
    if (objData.page_title) {
      pageTitle = objData.page_title
    }

    // error_event 帶入暫存pageTitle
    if (objData.event === 'error_event') {
      objData.page_title = pageTitle ? pageTitle : document.title
    }
  }

  const analytics = {
    push,
  }

  return {
    provide: {
      analytics,
    },
  }
})
